import { AsymmetricEncryptionType } from '@streamr/trackerless-network';
import { utf8ToBinary } from '@streamr/utils';
import { createRSAKeyPair } from '@/createRSAKeyPair';
/**
 * The length of encrypted data determines the minimum length. In StreamrClient we use RSA
 * for encrypting 32 byte GroupKeys. In Node environment 585 bits is enough, but in
 * browser environment we need 640.
 * https://en.wikipedia.org/wiki/Optimal_asymmetric_encryption_padding
 */
export const MIN_KEY_LENGTH = 640;
export class RSAKeyPair {
    // the keys are in PEM format
    privateKey;
    publicKey;
    constructor(privateKey, publicKey) {
        this.privateKey = privateKey;
        this.publicKey = publicKey;
    }
    getPublicKey() {
        // Note: the public key is passed around as an utf-8 encoded string for some legacy reasons
        return utf8ToBinary(this.publicKey);
    }
    getPrivateKey() {
        // Note: the public key is passed around as an utf-8 encoded string for some legacy reasons
        return utf8ToBinary(this.privateKey);
    }
    // eslint-disable-next-line class-methods-use-this
    getEncryptionType() {
        return AsymmetricEncryptionType.RSA;
    }
    static async create(keyLength) {
        const { privateKey, publicKey } = await createRSAKeyPair(keyLength);
        return new RSAKeyPair(privateKey, publicKey);
    }
}
